var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.38123 16.1794c-.56575 0-.90101-.4085-.90101-.838 0-.2409.10477-.4923.33526-.6809l10.91692-9.16556c.7857-.65992 1.7496-.65992 2.5249 0 1.616 1.35593 2.6999 2.26479 3.5348 2.96487 2.3376 1.96009 2.7233 2.28359 7.3716 6.20069.22.1886.3248.3981.3248.7123 0 .5028-.3981.8066-.8905.8066-.2934 0-.5343-.1571-.7439-.3352l-10.4873-8.79895c-.2305-.2095-.5134-.2095-.7439 0l-10.48733 8.79895c-.22002.1781-.46098.3352-.75434.3352z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.10628 27c-1.47722 0-2.35727-.8589-2.35727-2.3045v-8.3066l8.61199-7.21725c.3876-.32471.8591-.3352 1.2572 0l8.612 7.21725v8.3066c0 1.4456-.8696 2.3045-2.3468 2.3045h-3.8834v-7c0-.5523-.4477-1-1-1h-4c-.5523 0-1 .4477-1 1v7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 9.83069c-.946-.79524-1.7461-1.46759-2.9891-2.51202.0895-.74292.7221-1.31867 1.4891-1.31867.8284 0 1.5.67157 1.5 1.5z",
    opacity: 0.6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.b14214e43e3ddfdef4523ffe7a3d6da3.svg";
export { ForwardRef as ReactComponent };